"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by edgar.torosyan on 7/21/17.
 */
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var TabDeletePopupComponent = /** @class */ (function () {
    function TabDeletePopupComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.deleteContentTick = false;
    }
    TabDeletePopupComponent.prototype.tickChange = function (event) {
        this.deleteContentTick = event;
    };
    TabDeletePopupComponent.prototype.confirmButton = function (acceptDelete) {
        this.dialogRef.close({
            acceptDelete: acceptDelete,
            deleteContent: !this.deleteContentTick,
        });
    };
    TabDeletePopupComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'tab-delete-popup',
            template: require('./tab-delete-popup.component.html'),
        }),
        __metadata("design:paramtypes", [material_1.MatDialogRef])
    ], TabDeletePopupComponent);
    return TabDeletePopupComponent;
}());
exports.TabDeletePopupComponent = TabDeletePopupComponent;
//# sourceMappingURL=tab-delete-popup.component.js.map